import { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { archiveOwner, unarchiveOwner } from 'store/owners/actions'
import type { ArchiveOwnerResponse } from 'store/owners/types'

export interface UseArchiveOwnerResult {
  archiveOwner: (ownerId: string) => Promise<{ success: boolean; data?: ArchiveOwnerResponse; error?: any }>
  unarchiveOwner: (ownerId: string) => Promise<{ success: boolean; data?: ArchiveOwnerResponse; error?: any }>
  isLoading: boolean
}

export const useArchiveOwner = (): UseArchiveOwnerResult => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const handleArchiveOwner = useCallback(async (ownerId: string): Promise<{ success: boolean; data?: ArchiveOwnerResponse; error?: any }> => {
    setIsLoading(true)

    return new Promise((resolve) => {
      dispatch(archiveOwner(
        { ownerId },
        (result: { success: boolean; data?: ArchiveOwnerResponse; error?: any }) => {
          setIsLoading(false)
          resolve(result)
        }
      ))
    })
  }, [dispatch])

  const handleUnarchiveOwner = useCallback(async (ownerId: string): Promise<{ success: boolean; data?: ArchiveOwnerResponse; error?: any }> => {
    setIsLoading(true)

    return new Promise((resolve) => {
      dispatch(unarchiveOwner(
        { ownerId },
        (result: { success: boolean; data?: ArchiveOwnerResponse; error?: any }) => {
          setIsLoading(false)
          resolve(result)
        }
      ))
    })
  }, [dispatch])

  return {
    archiveOwner: handleArchiveOwner,
    unarchiveOwner: handleUnarchiveOwner,
    isLoading,
  }
}
